import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const r = i((c, a) => /* @__PURE__ */ s.jsx(
  e,
  {
    ref: a,
    ...c,
    image: (l) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...l,
        children: [
          /* @__PURE__ */ s.jsx("g", { clipPath: "url(#clip0_3410_69084)", children: /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M12.27 2.77a.959.959 0 1 0 0 1.918.959.959 0 0 0 0-1.918M8 10.667a2.667 2.667 0 1 1 0-5.333 2.667 2.667 0 0 1 0 5.333m0-6.775a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217M8 0C5.828 0 5.555.01 4.701.047 3.85.087 3.268.222 2.76.42a3.9 3.9 0 0 0-1.417.923c-.445.445-.719.89-.923 1.416-.198.51-.333 1.09-.372 1.942C.01 5.555 0 5.827 0 8s.01 2.445.048 3.299c.04.851.174 1.433.372 1.941.204.526.478.972.923 1.417a3.9 3.9 0 0 0 1.417.923c.508.198 1.09.333 1.941.372C5.555 15.99 5.828 16 8 16c2.173 0 2.445-.01 3.299-.048.851-.04 1.433-.174 1.942-.372a3.9 3.9 0 0 0 1.417-.923c.444-.445.718-.89.922-1.417.198-.508.334-1.09.372-1.941.04-.854.048-1.127.048-3.299 0-2.173-.009-2.445-.048-3.299-.038-.851-.174-1.433-.372-1.942a3.9 3.9 0 0 0-.922-1.416A3.9 3.9 0 0 0 13.24.42c-.509-.198-1.09-.334-1.942-.373C10.445.01 10.173 0 8 0m0 1.442c2.137 0 2.39.008 3.233.046.78.036 1.203.165 1.485.276.374.144.64.318.92.598s.454.546.598.92c.11.282.24.705.276 1.485.038.844.046 1.096.046 3.233s-.008 2.388-.046 3.233c-.036.78-.165 1.203-.276 1.484-.144.374-.318.64-.598.921-.28.28-.546.453-.92.598-.282.11-.705.24-1.485.276-.844.038-1.096.046-3.233.046s-2.388-.008-3.232-.046c-.78-.036-1.204-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.599-.92c-.11-.282-.24-.706-.276-1.485-.038-.845-.047-1.097-.047-3.233s.009-2.39.047-3.233c.036-.78.166-1.203.276-1.485.145-.374.318-.641.599-.92.279-.28.545-.454.92-.598.28-.11.705-.24 1.485-.276.844-.038 1.096-.046 3.232-.046",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_3410_69084", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
r.displayName = "InstagramIcon";
export {
  r as InstagramIcon,
  r as default
};
//# sourceMappingURL=index.js.map
